<template>
<div>
  <breadcrumb :items="[{ text: 'Fornecedores', active: true }]" />
  <router-link class="btn btn-primary btn-add" to="/cadastrar-fornecedor"><i class="fa fa-plus"></i> Cadastrar fornecedor</router-link>
  <input v-model="filters.search" class="form-control mb-2" placeholder="Buscar...">
  <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
  <loading :loading="!suppliers && !error" msg="Carregando lista de fornecedores" />
  <no-item :list="suppliers" />
  <div v-if="suppliers && suppliers.length">
    <b-table stacked="lg" :fields="table_fields" :items="suppliers" :sort-by="'name'" :filter="filters.search">
      <template slot="thumb" slot-scope="data">
        <router-link :to="'/editar-fornecedor/'+ data.item._id">
          <img :src="defaultThumb(data.item.images)" class="thumb">
        </router-link>
      </template>
      <template slot="name" slot-scope="data">
        <router-link :to="'/editar-fornecedor/'+ data.item._id">
          {{data.item.name}}
        </router-link>
      </template>
      <template slot="address" slot-scope="data">
        <span v-if="data.value">{{data.value | city}}</span>
      </template>
      <template slot="actions" slot-scope="data">
        <div class="btn-group btn-group-sm">
          <router-link :to="'/editar-fornecedor/'+ data.item._id" class="btn btn-primary">
            <i class="fa fa-pencil"></i>
          </router-link>
          <a @click="remove(data.item._id)" class="btn btn-secondary">
            <i class="fa fa-close"></i>
          </a>
        </div>
      </template>
    </b-table>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import NoItem from '@/components/NoItem'

export default {

  name: 'Suppliers',

  data() {
    return {

      filters: {
        search: null
      },
      table_fields: [
        {
          key: 'thumb',
          label: '',
          class: "td-logo",
        },
        {
          key: 'name',
          label: 'Organização',
          sortable: true
        },
        {
          key: 'address',
          label: 'Cidade',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Ações',
          'class': 'td-actions'
        },
      ],
      suppliers: null
    }
  },

  created() {
    this.list()
  },

  methods: {
    async list() {
      axios.get('suppliers').then(response => {
        this.suppliers = response.data
      }).catch(this.showError)

    },
    remove(id) {
      if (confirm("Tem certeza que deseja excluír?")) {
        axios.delete('suppliers/' + id).then(() => {
          this.list()
        }).catch(this.showError)
      }
    }
  },

  components: {
    Loading,
    NoItem
  }

};
</script>
